import { NgModule } from '@angular/core';
import { NbCardModule, NbIconModule, NbInputModule, NbToggleModule, NbActionsModule, NbSpinnerModule } from '@nebular/theme';
import { Ng2SmartTableModule } from 'ng2-smart-table';

import { ThemeModule } from '../../@theme/theme.module';
import { routedComponents, LicenceKeysRoutingModule } from './database-routing.module';
import { FormsModule } from '@angular/forms';
import { NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { EditDatabaseComponent } from './edit-database/edit-database.component';


@NgModule({
  imports: [
    NbCardModule,
    NbIconModule,
    NbInputModule,
    ThemeModule,
    LicenceKeysRoutingModule,
    Ng2SmartTableModule,
    FormsModule,
    NbToggleModule,
    NgbModule,
    NgMultiSelectDropDownModule, 
    NbActionsModule,
    NbSpinnerModule,
  ],
  entryComponents: [
    EditDatabaseComponent,
  ],
  declarations: [
    EditDatabaseComponent,
    ...routedComponents,
  ],
})
export class DatabaseModule { }
